<template>
  <div
    class="min-height dashboard-screen-container inputcontainer theme--light"
  >
    <CRow>
      <CCol sm="6" class="d-align">
        <h3 class="m-0">Services Dashboard</h3>
      </CCol>
      <CCol sm="6">
        <CRow>
          <CCol sm="6" class="form-group search-div">
            <label for>Search by city</label>
            <div class="col-sm-12 p-0 search-div">
              <input
                type="text"
                class="form-control"
                placeholder="Search"
                v-model="search"
              />
              <!-- <div class="search-svg">
                <searchSVG />
              </div>-->
              <!-- <div class="search-svg">
              <crossSVG />
              </div>-->
              <div
                v-if="search !== ''"
                class="search-svg position-absolute"
                @click="clearSearch()"
              >
                <crossSVG />
              </div>
            </div>
          </CCol>
          <CCol sm="6" class="datepicker pos-r">
            <label for>Date Range</label>
            <datepicker
              v-model="dateRange"
              @input="dateChange()"
              ref="datepicker"
              :model-config="datePickerConfig"
              :max-date="new Date()"
              is-range
              :masks="{ input: 'DD-MM-YYYY' }"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  :value="
                    !!inputValue.start && !!inputValue.end
                      ? inputValue.start + ' - ' + inputValue.end
                      : 'DD/MM/YYYY'
                  "
                  v-on="inputEvents.start"
                  class="form-control position-relative"
                  placeholder="DD-MM-YYYY"
                />

                <div
                  v-if="!!inputValue.start && !!inputValue.end"
                  class="cross-svg"
                  @click="resetActiveDate"
                >
                  <crossSVG />
                </div>
              </template>
            </datepicker>
            <div class="calendarsvg pos-svg pos-a">
              <calendarSVG />
            </div>
          </CCol>
        </CRow>
      </CCol>
    </CRow>
    <!-- ........................................................... -->
    <CRow>
      <CCol sm="12">
        <v-tabs
          v-model="tabs"
          background-color="transparent"
          class="border-bottom border-top"
        >
          <v-tab v-for="(item, i) in items" :key="i">{{ item.tabName }}</v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Book Appointment</h5>
                          <small>(Total Transaction Amount)</small>
                          <h5 class="text-success mb-0">
                            {{ appointment.totalAmount | currency }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Total Online Transactions</h6>
                          <small>(via Payment Gateway)</small>
                        </div>
                        <div>
                          <h6 class="white-space">
                            {{ appointment.totalOnline | currency }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Total Offline Transactions</h6>
                          <small>(via cash, cheque etc)</small>
                        </div>
                        <div>
                          <h6>{{ appointment.totalOffline | currency }}</h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Utility Fees</h6>
                          <small>(Docsmart + Payment Gateway)</small>
                        </div>
                        <div>
                          <h6>{{ appointment.utilityFees | currency }}</h6>
                        </div>
                      </div>
                      <div class="d-just-space">
                        <div>
                          <h6 class="mb-0">DocSmart Income</h6>
                          <small>(Docsmart income from utility fees)</small>
                        </div>
                        <div>
                          <h6>{{ appointment.income | currency }}</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Online Consultation</h5>
                          <small>(Total transaction Amount)</small>
                          <h5 class="text-success mb-0">
                            {{ oc.totalAmount | currency }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Utility fees</h6>
                          <small>
                            (Docsmart income + amount to be paid to the vendors)
                          </small>
                        </div>
                        <div>
                          <h6 class="white-space">
                            {{ oc.utilityFees | currency }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">DocSmart OC Income</h6>
                        </div>
                        <div>
                          <h6 class="white-space">{{ oc.income | currency }}</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Video Consultation Fees</h5>
                          <small>(Total Transaction Amount)</small>
                          <h5 class="text-success mb-0">
                            {{ oc.videoFees | currency }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Vendor fees</h6>
                        </div>
                        <div>
                          <h6 class="white-space">
                            {{ oc.vendorFees | currency }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">DocSmart VC Income</h6>
                        </div>
                        <div>
                          <h6 class="white-space">{{ oc.vcIncome | currency }}</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Doctors Home Visit</h5>
                          <small>(Total Transaction Amount)</small>
                          <h5 class="text-success mb-0">
                            {{ homeVisit.totalAmount | currency }}
                          </h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Total Online Transactions</h6>
                          <small>(via Payment Gateway)</small>
                        </div>
                        <div>
                          <h6 class="white-space">
                            {{ homeVisit.totalOnline | currency }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Utility Fees</h6>
                        </div>
                        <div>
                          <h6 class="white-space">
                            {{ homeVisit.utilityFees | currency }}
                          </h6>
                        </div>
                      </div>
                      <div class="d-just-space">
                        <div>
                          <h6 class="mb-0">DocSmart Income</h6>
                        </div>
                        <div>
                          <h6 class="white-space">
                            {{ homeVisit.income | currency }}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. doctor .............................. -->
          <!-- <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view :src="'/img/avatars/transfer.png'" class="mr-1"></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Book Appointment</h5>
                          <small>(Total Transaction Amount)</small>
                          <h5 class="text-success mb-0">&#8377; 452211</h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Total Online Transactions</h6>
                          <small>(via Payment Gateway)</small>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 25097</h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Total Offline Transactions</h6>
                          <small>(via cash, cheque etc)</small>
                        </div>
                        <div>
                          <h6>&#8377; 58</h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Utility Fees</h6>
                          <small>(Docsmart + CC avenue)</small>
                        </div>
                        <div>
                          <h6>&#8377; 28</h6>
                        </div>
                      </div>
                      <div class="d-just-space">
                        <div>
                          <h6 class="mb-0">DocSmart Income</h6>
                          <small>(Docsmart income from utility fees)</small>
                        </div>
                        <div>
                          <h6>&#8377; 28</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view :src="'/img/avatars/transfer.png'" class="mr-1"></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Online Consultation</h5>
                          <small>(Total transaction Amount)</small>
                          <h5 class="text-success mb-0">&#8377; 452211</h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Utility fees</h6>
                          <small>
                            (Docsmart income + amount to be paid to the
                            vendors)
                          </small>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">DocSmart OC Income</h6>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view :src="'/img/avatars/transfer.png'" class="mr-1"></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Video Consultation Fees</h5>
                          <small>(Total Transaction Amount)</small>
                          <h5 class="text-success mb-0">&#8377; 452211</h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Vendor fees</h6>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">DocSmart VC Income</h6>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-flex mb-2">
                        <div class="icon-div">
                          <image-view :src="'/img/avatars/transfer.png'" class="mr-1"></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Doctors Home Visit</h5>
                          <small>(Total Transaction Amount)</small>
                          <h5 class="text-success mb-0">&#8377; 452211</h5>
                        </div>
                      </div>
                      <hr class="hr-line" />
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Total Online Transactions</h6>
                          <small>(via Payment Gateway)</small>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                      <div class="d-just-space mb-3">
                        <div>
                          <h6 class="mb-0">Utility Fees</h6>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                      <div class="d-just-space">
                        <div>
                          <h6 class="mb-0">DocSmart Income</h6>
                        </div>
                        <div>
                          <h6 class="white-space">&#8377; 452211</h6>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </v-card-text>
            </v-card>
          </v-tab-item> -->
          <!-- ............................. allied branches .............................. -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <CRow>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Vendors</h5>
                          <h5 class="text-success mb-0">452211</h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Items</h5>
                          <h5 class="text-success mb-0">452211</h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Items sold</h5>
                          <h5 class="text-success mb-0">452211</h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                  <CCol sm="6" md="3">
                    <div class="value-card">
                      <div class="d-align">
                        <div class="icon-div">
                          <image-view
                            :src="'/img/avatars/transfer.png'"
                            class="mr-1"
                          ></image-view>
                        </div>
                        <div class="ml-4">
                          <h5 class="mb-0">Total Transactions</h5>
                          <h5 class="text-success mb-0">452211</h5>
                        </div>
                      </div>
                    </div>
                  </CCol>
                </CRow>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- ............................. vendors .............................. -->
        </v-tabs-items>
      </CCol>
    </CRow>
  </div>
</template>
<script>
const Datepicker = () => import("v-calendar/lib/components/date-picker.umd");
import { pickSvg } from "@/views/SVG";
const Image = () => import("@/components/image.vue");
import Config from "@/config.js";
const API_URL = `${Config.ACCOUNTS_URL}ds-accounts-be`;

export default {
  components: {
    Datepicker,
    ...pickSvg("crossSVG", "searchSVG"),
    "image-view": Image,
  },
  created() {
    this.getDashboard();
  },
  data() {
    return {
      search: "",
      appointment: {
        income: 0,
        utilityFees: 0,
        totalOnline: 0,
        totalOffline: 0,
        totalAmount: 0,
      },
      oc: {
        vcIncome: 0,
        vendorFees: 0,
        videoFees: 0,
        income: 0,
        utilityFees: 0,
        totalAmount: 0,
      },
      homeVisit: {
        income: 0,
        utilityFees: 0,
        totalOnline: 0,
        totalAmount: 0,
      },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00",
        },
        end: {
          timeAdjust: "23:59:59",
        },
      },
      dateRange: {
        start: "",
        end: "",
      },
      tabs: null,
      items: [
        { tabName: "Doctor" },
        // { tabName: "Allied Branches" },
        // { tabName: "Vendors" },
      ],
    };
  },
  filters: {
    currency(val) {
      return new Intl.NumberFormat("en-IN", {
        style: "currency",
        currency: "INR"
      }).format(val);
    },
  },
  methods: {
    clearSearch() {
      this.search = "";
    },
    dateChange() {
      // this.getBlogList();
    },
    getDashboard() {
      this.$http.get(`${API_URL}/transaction/services-dashboard`).then(
        (response) => {
          const { status, data } = response.data;
          if (status) {
            for (const entry of data) {
              const { _id, paid, charges, platformCharges } = entry;
              if (_id === 'APPOINTMENT_ONLINE') {
                this.appointment.totalOnline += paid;
                this.appointment.totalOnline += charges;
                this.appointment.utilityFees += charges;
              }
              if (_id === 'APPOINTMENT_OFFLINE') {
                this.appointment.totalOffline += paid;
              }
              if (_id === 'HOME_VISIT_ONLINE') {
                this.homeVisit.totalOnline += paid;
                this.homeVisit.totalOnline += charges;
                this.homeVisit.totalAmount += paid;
                this.homeVisit.totalAmount += charges;
                this.homeVisit.utilityFees += charges;
              }
              if (_id === 'ONLINE_CONSULTATION_ONLINE') {
                this.oc.totalAmount += paid;
                this.oc.totalAmount += charges;
                this.oc.utilityFees += charges;
                this.oc.vendorFees += platformCharges;
              }
            }

            this.appointment.totalAmount = this.appointment.totalOnline + this.appointment.totalOffline;
            
          }
        },
        (err) => {
          console.log(err);
        }
      );
    },
  },
};
</script>